import { FC } from 'react';
import styled from '@emotion/styled';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import BaseImage from '@base/Image';
import { addBannerParamToURL } from '@cont/NewPreSubscribed/utils';

const BannerImage = styled(BaseImage)`
  height: auto;
  width: 100%;
  border-radius: 8px;
  box-shadow: ${boxShadowGenerator()};
`;

const BannerContainer = styled.a`
  display: block;
  position: relative;
`;

type BlockDataType = {
  url: string;
  img: string;
};

type GenericBannerProps = {
  block: {
    data: BlockDataType[];
  };
};

const GenericBanner: FC<GenericBannerProps> = ({ block }) => {
  const data = block?.data[0];
  return (
    <BannerContainer
      href={addBannerParamToURL(data.url)}
      target="_blank"
      rel="noreferrer"
    >
      <BannerImage src={data.img} alt="banner" layout="fill" />
    </BannerContainer>
  );
};

export default GenericBanner;
